import {ExternalBackend} from "./ExternalBackend";

export class SegpayWorkflow extends ExternalBackend {

  constructor(params) {
    super("segpay", params);
  }
}